const MANAGEMENT_PAGE = {
  title: 'Gerenciamento',
  hexaTitle: 'Gerenciamento financeiro',
  salesManagementTitle: 'Gerenciamento das vendas',
  newRestitutionPageAlert: {
    message:
      'NOVA PÁGINA DE RESTITUIÇÕES:\nAgora você tem acesso completo ao detalhamento das restituições semanais',
    buttonText: 'Acessar Restituições',
  },
  cashBalanceCard: {
    title: 'Fechamento de caixa',
    printText: 'Imprimir',
    downloadText: 'Baixar planilha',
    printTitle: 'Zé Delivery',
    printSubtitle: 'Fechamento de caixa',
    startDate: 'Data inicial',
    endDate: 'Data final',
    printDate: 'Data de impressão',
    total: 'Total',
    valuesTitle: 'Valores',
    numberOfOrders: 'Nº de pedidos',
    partner: 'Parceiro',
    address: 'Endereço',
    tooltipInfo: 'Consolidado de vendas agrupado por pedido ou por entregador.',
    errorRangeDate: 'Data inicial é maior que data final.',
    explanationText:
      'Selecione um período de até 2 dias para visualizar o fechamento de caixa. Serão considerados todos os pedidos com o status: “Entregue”',
    byOrders: 'Por pedido',
    byDeliveryperson: 'Por entregador',
  },
  totalRevenueCard: {
    title: 'Vendas',
    storeSales: 'Valor total',
    tooltipInfo: 'Valor total dos pedidos ao longo do período selecionado.',
    BRLAbbreviation: 'R$',
    disabledReportinfo:
      'Os dados deste período não estão disponíveis para baixar.',
    altMaskTotalRevenueOpen:
      'icone de máscara aberta para visualizar valor total do caixa',
    altMaskTotalRevenueClose:
      'icone de máscara fechada para esconder valor total do caixa',
  },
  reimbursementCard: {
    title: 'Restituição',
    tooltipInfo:
      'Total da restituição sobre as vendas dos produtos AMBEV. Pode apresentar valores incompletos para a semana corrente.',
    consultInTheWorksheet: 'Consultar na planilha',
    markup: 'Markup',
    incentive: 'Incentivo',
    shipping: 'Frete',
    coupon: 'Cupom',
  },
  noDataForPeriod: 'Não há dados para o período selecionado.',
  noOrderForPeriod: 'Não há pedidos para o período selecionado',
  invalidWeek: 'Semana selecionada não pode ser maior do que a atual',
  downloadReport: 'Baixar planilha',
  apply: 'Aplicar',
  day: 'Dia',
  period: 'Período',
  change: 'Alterar',
  thisMonth: 'Este mês',
  lastWeek: 'Semana passada',
  currentWeek: 'Semana atual',
  yesterday: 'Ontem',
  today: 'Hoje',
  custom: 'Personalizado',
  from: 'De',
  until: 'até',
  at: 'às',
  tryAgain: 'Tentar novamente',
  couldnLoadData: 'Ops, não conseguimos carregar os dados!',
  defaultRequestErrorMessage: 'Houve um erro, tente novamente mais tarde.',
  nice: 'Legal',
  managementNews: 'Novidade na sua página de Gerenciamento!',
  disabledDownloadAltText: 'Ícone de download desabilitado',
  downloadIcon: 'Ícone de download',
  filter: 'Filtrar',
  downloadSpreadsheet: 'Baixar planilha',
  submit: 'Baixar relatório',
}

export default MANAGEMENT_PAGE
